// Brücke zwischen der Rahmen-Website (Seitenleiste, Anmeldung, Befehlspalette) und den Programm-Websites, die der
// Rahmen im Inhaltsbereich lädt. Gleiche Herkunft, Nachrichten über postMessage. Läuft ein Programm allein (eigener
// Dev-Server oder /app/… direkt aufgerufen), gibt es keinen Rahmen und das Programm zeigt seine eigene Seitenleiste.

/** Unter dieser Adresse liefert der Torweg die Programme aus (/app/posteingang/… → Programm Posteingang). */
export const PROGRAMM_BASIS = "/app";

export type Nachricht =
  | { typ: "imho:ort"; pfad: string; titel: string }  // Programm → Rahmen: hier bin ich jetzt
  | { typ: "imho:gehe"; pfad: string }  // in beide Richtungen: bitte dorthin (ggf. anderes Programm)
  | { typ: "imho:palette" }  // Programm → Rahmen: Befehlspalette öffnen (⌘K im Inhalt)
  | { typ: "imho:menue" };  // Programm → Rahmen: Seitenleiste mobil öffnen

const MARKE = "__imhoRahmen";

/** Im Rahmen aufgerufen? (Der Rahmen setzt eine Marke auf seinem Fenster.) */
export function imRahmen(): boolean {
  try {
    return window.parent !== window && (window.parent as unknown as Record<string, unknown>)[MARKE] === true;
  } catch {
    return false;
  }
}

/** Ist dieses Fenster selbst der Rahmen? */
export function istRahmen(): boolean {
  return (window as unknown as Record<string, unknown>)[MARKE] === true;
}

export function rahmenMarkieren(): void {
  (window as unknown as Record<string, unknown>)[MARKE] = true;
}

export function anRahmen(n: Nachricht): void {
  window.parent.postMessage(n, window.location.origin);
}

/** Basis der Programm-Website: /app über den Torweg, leer beim eigenen Dev-Server. */
export function programmBasis(): string {
  const p = window.location.pathname;
  return p === PROGRAMM_BASIS || p.startsWith(`${PROGRAMM_BASIS}/`) ? PROGRAMM_BASIS : "";
}

export function istNachricht(e: MessageEvent): e is MessageEvent<Nachricht> {
  return e.origin === window.location.origin && typeof e.data === "object" && e.data !== null
    && typeof (e.data as { typ?: unknown }).typ === "string" && (e.data as { typ: string }).typ.startsWith("imho:");
}
